// Common column definitions to reduce duplication across performance table headers
// Each column definition includes the basic structure with columnKey and header

export const COMMON_COLUMNS = {
  // Core identification columns
  id: { columnKey: "id", header: "ID" },
  externalId: { columnKey: "externalId", header: "External ID" },
  identifier: { columnKey: "identifier", header: "External ID" },

  // User-related columns
  userId: { columnKey: "userId", header: "User ID" },
  profileId: { columnKey: "profileId", header: "Profile Id" },
  user: { columnKey: "user", header: "User ID" },
  deviceId: { columnKey: "deviceId", header: "Device ID" },

  // Campaign and performance columns
  campaignName: { columnKey: "campaignName", header: "Campaign Name" },
  campaign: { columnKey: "campaign", header: "Campaign Name" },
  performanceDate: { columnKey: "performanceDate", header: "Performance Date" },
  startDate: { columnKey: "startDate", header: "Performance Date" },

  // Outcome columns
  outcomeName: { columnKey: "outcomeName", header: "Outcome Name" },
  outcomeNameFull: { columnKey: "outcomeName", header: "Outcome Name" },
  outcomeQuantity: { columnKey: "outcomeQuantity", header: "Outcome Quantity" },

  // Status and channel columns
  status: { columnKey: "status", header: "Status" },
  channel: { columnKey: "channel", header: "Channel" },

  // Package-specific columns
  packageCode: { columnKey: "packageCode", header: "Code" },
  sku: { columnKey: "sku", header: "SKU" },
  freshByDate: { columnKey: "freshByDate", header: "Fresh By Date" },

  // Location columns
  geolocation: { columnKey: "geolocation", header: "Geolocation" },

  // Activity type
  activityType: { columnKey: "activityType", header: "Activity Type" },

  // Code scan specific columns
  referralIdentifier: { columnKey: "externalId", header: "Referral Identifier" },
  userProfileId: { columnKey: "profileId", header: "User ID" },
};

// Enhanced column definitions with additional properties (className, etc.)
export const ENHANCED_COLUMNS = {
  id: {
    ...COMMON_COLUMNS.id,
    className: "performances-column-id",
  },
  identifier: {
    ...COMMON_COLUMNS.identifier,
    className: "performances-column-identifier",
  },
  user: {
    ...COMMON_COLUMNS.user,
    className: "performances-column-user",
  },
  profileId: {
    ...COMMON_COLUMNS.profileId,
    className: "performances-column-profileId",
  },
  channel: {
    ...COMMON_COLUMNS.channel,
    className: "performances-column-channel",
  },
  startDate: {
    ...COMMON_COLUMNS.startDate,
    className: "performances-column-startDate",
  },
  campaign: {
    ...COMMON_COLUMNS.campaign,
    className: "performances-column-campaign",
  },
  outcomeName: {
    ...COMMON_COLUMNS.outcomeNameFull,
    className: "performances-column-outcomeName",
  },
  outcomeQuantity: {
    ...COMMON_COLUMNS.outcomeQuantity,
    className: "performances-column-outcomeQuantity",
  },
  activityType: {
    ...COMMON_COLUMNS.activityType,
    className: "performances-column-activityType",
  },
  status: {
    ...COMMON_COLUMNS.status,
    itemClassName: "performances-widget-status-type",
  },
};

// Helper function to build header arrays from column keys
export const buildHeaderData = (columnKeys, useEnhanced = false) => {
  const columnSource = useEnhanced ? ENHANCED_COLUMNS : COMMON_COLUMNS;
  return columnKeys.map((key) => {
    const column = columnSource[key];
    if (!column) {
      console.warn(`Column definition not found for key: ${key}`);
      return { columnKey: key, header: key };
    }
    return column;
  });
};

// Predefined header combinations for common use cases
export const HEADER_COMBINATIONS = {
  // Package scan specific headers
  packageScan: [
    "id",
    "externalId",
    "userId",
    "profileId",
    "channel",
    "campaignName",
    "performanceDate",
    "outcomeName",
    "outcomeQuantity",
    "activityType",
    "status",
    "packageCode",
    "sku",
    "freshByDate",
  ],

  // Code scan generic headers
  codeScan: [
    "id",
    "externalId",
    "userId",
    "profileId",
    "channel",
    "campaignName",
    "performanceDate",
    "outcomeName",
    "outcomeQuantity",
    "status",
  ],

  // Check-in headers
  checkIn: [
    "id",
    "userProfileId",
    "performanceDate",
    "campaignName",
    "outcomeName",
    "outcomeQuantity",
    "referralIdentifier",
    "geolocation",
    "status",
  ],

  // Default performance table headers (enhanced with styling)
  default: [
    "id",
    "identifier",
    "user",
    "profileId",
    "channel",
    "startDate",
    "campaign",
    "outcomeName",
    "outcomeQuantity",
    "activityType",
    "status",
  ],
};
